import _ from 'lodash'

// Vue Plugin to expose to Vue Components
const VueLodash = {
  install (app) {
    app.config.globalProperties.$_ = _
  }
}

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default ({ app }) => {
  // Expose globally
  window._ = _

  // Expose to Vue Components
  app.use(VueLodash)
}
